var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 735,
    height: 656,
    viewBox: "0 0 735 656",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9112 256.784C106.124 200.331 86.0585 134.317 142.967 94.0295C214.953 43.0677 314.985 -10.5057 428.507 14.955C541.299 40.2518 591.914 132.056 641.192 205.771C678.531 261.626 660.852 315.05 667.732 372.809C678.183 460.55 779.715 571.475 691.195 625.556C603.206 679.311 441.493 622.502 313.831 589.021C201.24 559.492 72.4891 524.192 21.8173 450.003C-25.533 380.677 64.1428 323.684 86.9112 256.784Z",
    stroke: "#FAFAFA",
    strokeWidth: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebBlob);
export default __webpack_public_path__ + "static/media/webBlob.33411b0b9589e6f6b4c678b9839be2da.svg";
export { ForwardRef as ReactComponent };